import DateDiff from 'date-diff';
import {HelperOptions} from 'handlebars';
import {LanguageUtility} from '../../utilities/language-utility';

/**
 * Calculates the difference between two dates.
 *
 * @param {string} dateString Base ISO 8601 date; use "now" to use the current date/time
 * @param {string} dateCompareString ISO 8601 date to compare the base date with; use "now" to use the current date/time
 * @param {HelperOptions} options Helper options
 * @author Philipp Seiler <sep@earlybird.at>
 */
const dateDiff = (
  dateString: string,
  dateCompareString: string,
  options: HelperOptions
): any => {
  const date = dateString === 'now' ? new Date() : new Date(dateString);
  date.setHours(0, 0, 0, 0);
  const compare = dateCompareString === 'now' ? new Date() : new Date(dateCompareString);
  compare.setHours(0, 0, 0, 0);
  const diff = new DateDiff(date, compare);
  const days = Math.floor(diff.days());
  const weeks = days > 6 ? Math.floor(days / 7) : 0;
  const daysLeftForWeeks = weeks > 0 ? days - weeks * 7 : 0;
  let formatted = '';

  // Provide some nicely formatted difference text, if the difference is not too large
  if (days >= 0 && weeks < 10) {
    if (days === 0) {
      formatted = LanguageUtility.translate('today');
    } else if (days === 1) {
      formatted = LanguageUtility.translate('tomorrow');
    } else if (days === 2 || days < 7) {
      formatted = LanguageUtility.translate('in') + ' ' + days + ' ' + LanguageUtility.translate('daysDativ');
    } else if (days === 7) {
      formatted = LanguageUtility.translate('inOneWeek');
    } else {
      if (weeks === 1) {
        formatted = LanguageUtility.translate('inOneWeek') + ' ' + LanguageUtility.translate('and') + ' ';
      } else {
        formatted = `${LanguageUtility.translate('in')} ${weeks} ${LanguageUtility.translate('weeks')} ${LanguageUtility.translate('and')} `;
      }
      if (daysLeftForWeeks === 1) {
        formatted += LanguageUtility.translate('oneDay');
      } else {
        formatted += daysLeftForWeeks + ' ' + LanguageUtility.translate('daysDativ');
      }
    }
  }

  const result = {
    days: days,
    months: diff.months(),
    years: diff.years(),
    formatted: formatted
  };
  return options.fn(result);
};
export default dateDiff;
